import {styled} from '@mui/material/styles';
import {mergeClasses} from 'minimal-shared/utils';
import {ComponentProps} from 'react';

import {layoutClasses} from './classes';

// ----------------------------------------------------------------------

export type MainSectionProps = ComponentProps<typeof MainRoot>;

export function MainSection({children, className, sx, ...other}: MainSectionProps) {
  return (
    <MainRoot className={mergeClasses([layoutClasses.main, className])} sx={sx} {...other}>
      {children}
    </MainRoot>
  );
}

// ----------------------------------------------------------------------

const MainRoot = styled('main')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
});
